import { render, staticRenderFns } from "./GameRouteConfigMoreBtn.vue?vue&type=template&id=5d30d6a8"
import script from "./GameRouteConfigMoreBtn.vue?vue&type=script&lang=js"
export * from "./GameRouteConfigMoreBtn.vue?vue&type=script&lang=js"
import style0 from "./GameRouteConfigMoreBtn.vue?vue&type=style&index=0&id=5d30d6a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports